var _path, _g, _path2, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEthereum = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_646_18437)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_646_18437",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_646_18437",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 23,
    height: 23
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7601 21.7601H-0.760254V-0.760254H21.7601V21.7601Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_646_18437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.786 10.4999C20.786 16.1825 16.1828 20.7857 10.5002 20.7857C4.81755 20.7857 0.214355 16.1825 0.214355 10.4999C0.214355 4.81731 4.81755 0.214111 10.5002 0.214111C16.1828 0.214111 20.786 4.81731 20.786 10.4999Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_646_18437)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_646_18437",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7942 0.205811H0.209961V20.79H20.7942V0.205811Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_646_18437)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    transform: "matrix(1 0 0 -1 0 21)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_646_18437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.683 4L10.6025 4.27346V12.208L10.683 12.2884L14.3661 10.1113L10.683 4Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6832 4L7 10.1113L10.6832 12.2884V8.43714V4Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6831 12.9858L10.6377 13.0411V15.8675L10.6831 16L14.3684 10.8098L10.6831 12.9858Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6832 16V12.9858L7 10.8098L10.6832 16Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6831 12.2885L14.3662 10.1114L10.6831 8.43726V12.2885Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 10.1114L10.6832 12.2885V8.43726L7 10.1114Z",
    fill: "#393939"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_646_18437"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_646_18437"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.36849,
    height: 12,
    fill: "white",
    transform: "translate(7 4)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEthereum);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ethereum.fc429ae093166778d0982b8d87f79b08.svg";